import { BlockRecord } from "models/view-models/block-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface PageBlockPathParams {
    pageId: number;
}

export interface PageBlockQueryParams {
    skip?: number;
    take?: number;
}

const endpoint: string = "pages/:pageId/blocks";
const resourceType = BlockRecord;

const PageBlockService = {
    useGetByPage: ServiceHookFactory.useNestedList<
        BlockRecord,
        PageBlockPathParams,
        PageBlockQueryParams
    >(resourceType, endpoint),
};

export default PageBlockService;
